/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
import React from 'react';

import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Table as FpayTable, Row, Col, Icon } from 'fpay-ui';

import { getEnv } from '@config';
import Tag from 'components/Tag';
import { useReports } from '@hooks';

import { format } from 'date-fns';
import { useBreakpoints } from '@hooks/NewBreakpoint';
import { SkeletonLoader } from './Table.SkeletonLoader';
import { DotsMenu } from './DotsMenu';
import { STATE_LABELS, REPORT_TYPE_LABELS, TAG_TYPE } from './constants';

const { publicPath } = getEnv();

const StyledRow = styled(Row)`
  > div {
    height: inherit;
    font-size: 12px;
    align-items: center;
    display: flex;
    justify-content: flex-start;

    ${({ theme }) => theme.newBreakpoint('new_lg')} {
      font-size: 14px;
    }
  }

  > div:last-of-type {
    justify-content: ${({ header }) => (header ? 'flex-start' : 'space-between')};
  }
`;

const Container = styled.div`
  display: unset;

  ${({ theme }) => theme.newBreakpoint('new_sm')} {
    display: none;
  }
`;

const RotatedIcon = styled(Icon)`
  margin-left: 2px;
  transform: rotate(90deg);
  width: 20px;
  height: 20px;

  ${({ theme }) => theme.newBreakpoint('new_lg')} {
    margin-left: 5px;
    width: 24px;
    height: 24px;
  }
`;

const NoReports = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 50vh;
  text-align: center;

  > img {
    height: 152px;
    width: 152px;
  }

  > div:first-of-type {
    padding-top: 5px;
    font-size: 24px;

    ${({ theme }) => theme.newBreakpoint('new_sm')} {
      width: 240px;
    }
  }

  > div:last-child {
    color: #a2a7ba;
    padding-top: 10px;
    ${({ theme }) => theme.newBreakpoint('new_sm')} {
      width: 300px;
    }
  }
`;

const period = ({ startDate, endDate }) =>
  `${format(new Date(startDate), 'dd/MM/yyyy')} - ${format(new Date(endDate), 'dd/MM/yyyy')}`;

export const Table = ({ skeleton }) => {
  const { t } = useTranslation();
  const { reports: totalReports, reportsRangeToShow, reportsTypeToShow } = useReports();
  const { breakpoint } = useBreakpoints();

  const reports = reportsTypeToShow || totalReports;
  const currePageReportList = reports?.slice(reportsRangeToShow[0], reportsRangeToShow[1]) ?? [];

  return (
    <Container>
      {skeleton ? (
        <SkeletonLoader />
      ) : reports?.length === 0 && breakpoint !== 'xs' ? (
        <>
          <NoReports>
            <img
              src={`${publicPath}/assets/images/empty-folder.svg`}
              id="empty-reports"
              alt="Sin reportes"
            />
            <div>{t('reportsScreen.emptyState.title')}</div>
            <div>{t('reportsScreen.emptyState.description')}</div>
          </NoReports>
        </>
      ) : (
        <FpayTable>
          <StyledRow header>
            <Col header>
              {t('reportsScreen.table.headers.date')}
              {/* <RotatedIcon icon="ic-transactions" /> // TODO: v3, order list */}
            </Col>
            <Col header>
              {t('reportsScreen.table.headers.period')}
              {/* <RotatedIcon icon="ic-transactions" /> // TODO: v3, order list */}
            </Col>
            <Col header>
              {t('reportsScreen.table.headers.type')}
              {/* <RotatedIcon icon="ic-transactions" /> // TODO: v3, order list */}
            </Col>
            {/*
            <Col header>
              {t('reportsScreen.table.headers.reportNumber')}
               <RotatedIcon icon="ic-transactions" /> // TODO: v3, order list and number report
            </Col>
               */}
            <Col header isHeader>
              {t('reportsScreen.table.headers.state')}
              {/* <RotatedIcon icon="ic-transactions" /> // TODO: v3, order list */}
            </Col>
          </StyledRow>
          {currePageReportList.map(
            ({
              created_at: date,
              start_date: startDate,
              end_date: endDate,
              type,
              report_id,
              state,
              link,
              _id,
            }) => (
              <StyledRow key={report_id}>
                <Col datajs={t('reportsScreen.table.headers.date')}>
                  {format(new Date(date), 'dd/MM/yyyy - HH:mm')}
                </Col>
                <Col datajs={t('reportsScreen.table.headers.period')}>
                  {period({ startDate, endDate })}
                </Col>
                <Col datajs={t('reportsScreen.table.headers.type')}>
                  {t(REPORT_TYPE_LABELS[type])}
                </Col>
                {/* <Col datajs={t('reportsScreen.table.headers.reportNumber')}>{report_id}</Col> // TODO: v3, order list and number report */}
                <Col datajs={t('reportsScreen.table.headers.state')}>
                  <Tag type={STATE_LABELS[state].tag}>{t(STATE_LABELS[state].key)}</Tag>
                  {[TAG_TYPE.SUCCESS, TAG_TYPE.ERROR].includes(STATE_LABELS[state].tag) && (
                    <DotsMenu link={link} id={_id} />
                  )}
                </Col>
              </StyledRow>
            )
          )}
        </FpayTable>
      )}
    </Container>
  );
};
